import { render, staticRenderFns } from "./InfoPopUp.vue?vue&type=template&id=36c9359b&scoped=true"
import script from "./InfoPopUp.vue?vue&type=script&lang=js"
export * from "./InfoPopUp.vue?vue&type=script&lang=js"
import style0 from "./InfoPopUp.vue?vue&type=style&index=0&id=36c9359b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c9359b",
  null
  
)

export default component.exports